
import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import api from '../../services/api';
import { toast } from 'react-toastify';
import { FaSpinner } from 'react-icons/fa';

const AdminProtectedRoute = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [isAdmin, setIsAdmin] = useState(false);

    useEffect(() => {
        const checkAdminStatus = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                setIsLoading(false);
                return;
            }

            try {
                // Verify token and get user role
                // We'll use the /auth/me or similar endpoint if available, or just rely on the fact that 
                // we stored the role on login. But purely relying on client side storage is weak.
                // Let's call /admin/stats or a lightweight admin endpoint to verify access.
                // Or better, let's decde the token if we can, but we don't have a library handy maybe.
                // Actually, let's try to fetch a protected admin resource.
                await api.get('/admin/stats');
                setIsAdmin(true);
            } catch (error) {
                console.error("Admin verification failed", error);
                setIsAdmin(false);
                if (error.response && error.response.status === 403) {
                    toast.error("Access Denied: Admin privileges required.");
                }
            } finally {
                setIsLoading(false);
            }
        };

        checkAdminStatus();
    }, []);

    if (isLoading) {
        return (
            <div className="flex items-center justify-center min-h-screen bg-gray-900">
                <FaSpinner className="text-4xl text-blue-500 animate-spin" />
            </div>
        );
    }

    return isAdmin ? <Outlet /> : <Navigate to="/admin/login" replace />;
};

export default AdminProtectedRoute;
